import { ProjectorMixin } from '@dojo/widget-core/mixins/Projector';
import Ticker from './widgets/Ticker';

// Create a projector to convert the virtual DOM produced by the application into the rendered page.
// For more information on starting up a Dojo 2 application, take a look at
// https://dojo.io/tutorials/002_creating_an_application/
const Projector = ProjectorMixin(Ticker);
const projector = new Projector();

// By default, append() will attach the rendered content to document.body.  To insert this application
// into existing HTML content, pass the desired root node to append().
projector.append(document.querySelector('app') as HTMLElement );



// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/main.ts